import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconColumnWideHalf: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="column-wide-half"><path d="M21.25 4.75H2.75V19.25H21.25V4.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M2.75 12H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconColumnWideHalf;
